<template>
  <div id="floatingMenuContainer" :class="{ trans: isTrans }">
    <div class="menuBackground">
      <img src="../assets/menu.gif" alt="Menu Icon" @click="showMenu = !showMenu" />
    </div>

    <transition name="fade">
      <div class="blackScreen" v-if="showMenu" @click="showMenu = false" />
    </transition>

    <transition enter-active-class="animated fadeInRight faster" leave-active-class="animated fadeOutRight faster">
      <div class="menuListContainer" v-if="showMenu">
        <router-link to="/home" class="menuOneRow">
          <span v-if="this.langChosen === 'gr'">บ้าน</span>
          <span v-else>Home</span>
        </router-link>

        <router-link to="/results" class="menuOneRow">
          <span v-if="this.langChosen === 'gr'">ผล</span>
          <span v-else>Results</span>
        </router-link>

        <router-link to="/faq" class="menuOneRow">
          <span v-if="this.langChosen === 'gr'">คำถามที่พบบ่อย</span>
          <span v-else>FAQ</span>
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showMenu: false,
      isTrans: false,
    };
  },
  mounted() {
    this.scrollDetect();
  },
  methods: {
    scrollDetect() {
      window.addEventListener('scroll', e => {
        if (e.target.scrollingElement.scrollTop / e.target.scrollingElement.scrollHeight < 0.2) {
          this.isTrans = false;
        } else {
          this.isTrans = true;
        }
      });
    },
  },
};
</script>

<style>
#floatingMenuContainer {
  position: fixed;
  right: 5vmin;
  top: 5vmin;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: bold;
  transition: opacity 1s;
}

.trans {
  opacity: 0.5;
}

#floatingMenuContainer:hover {
  opacity: 1;
}

.menuBackground {
  padding: 3vmin;
  padding-bottom: 2vmin;
  background-color: var(--yellowPrim);
  border-radius: 1.5vmin;
  width: 7vmin;
}

.menuBackground img {
  width: 100%;
  margin: 0;
}

.blackScreen {
  background-color: black;
  opacity: 0.5;
  position: fixed;
  z-index: -1;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
}

.menuListContainer {
  background-color: var(--yellowPrim);
  margin-top: 1vmin;
  border-radius: 1.5vmin;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.menuOneRow {
  padding: 4.5vmin;
  text-decoration: none;
  color: var(--darkColor);
}

.menuOneRow:active {
  background-color: var(--yellowPrim-lighter-2);
}

.router-link-active {
  background-color: var(--darkColor);
  color: var(--lightColor);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

@media all and (min-width: 768px) {
  #floatingMenuContainer {
    display: none;
  }
}
</style>
